module.exports = __webpack_public_path__ + "static/media/pedestrian.c793af58.svg";